import { e as _inheritsLoose, f as _defineProperty, g as _assertThisInitialized, c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import { createElement, Component } from 'react';
import 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import Box from './Box.js';
import '@emotion/is-prop-valid';
import { createPortal } from 'react-dom';
import { a as hoist } from './chunk-0cd02bff.js';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PortalComponent =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(PortalComponent, _React$Component);

  function PortalComponent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      wrapper: null
    });

    return _this;
  }

  var _proto = PortalComponent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var wrapper = document.createElement("div");
    document.body.appendChild(wrapper);
    this.setState({
      wrapper: wrapper
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var wrapper = this.state.wrapper;

    if (wrapper) {
      document.body.removeChild(wrapper);
    }
  };

  _proto.render = function render() {
    var wrapper = this.state.wrapper;

    if (wrapper) {
      return createPortal(createElement(Box, this.props), wrapper);
    }

    return null;
  };

  return PortalComponent;
}(Component);

var Portal = styled(hoist(PortalComponent, Box))(_templateObject(), theme("Portal"));
var Portal$1 = use(Portal, "div");

export default Portal$1;
